import { render, staticRenderFns } from "./UploadIntro.vue?vue&type=template&id=ab40db12&scoped=true&"
import script from "./UploadIntro.vue?vue&type=script&lang=js&"
export * from "./UploadIntro.vue?vue&type=script&lang=js&"
import style0 from "./UploadIntro.vue?vue&type=style&index=0&id=ab40db12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab40db12",
  null
  
)

export default component.exports